import { render, staticRenderFns } from "./genericShipmentView.vue?vue&type=template&id=7b10d052&scoped=true"
import script from "./genericShipmentView.vue?vue&type=script&lang=js"
export * from "./genericShipmentView.vue?vue&type=script&lang=js"
import style0 from "./genericShipmentView.vue?vue&type=style&index=0&id=7b10d052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b10d052",
  null
  
)

export default component.exports